import React, { useState } from "react";
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  Row,
  Alert
} from "react-bootstrap";
import { app } from "../../credenciales.js";
import style from "./Actividades.module.css";
import { addDoc, collection, getFirestore } from "firebase/firestore";
import Swal from 'sweetalert2';

const db = getFirestore(app);

const AgregarActividad = () => {
  const [activityName, setActivityName] = useState('');
  const [isSingleClass, setIsSingleClass] = useState(false);
  const [dates, setDates] = useState(['']);
  const [hour, setHour] = useState('');
  const [error, setError] = useState('');

  const handleCheckboxChange = (e) => {
    setIsSingleClass(e.target.checked);
    setDates(e.target.checked ? [''] : ['', '']);
  };

  const handleNameChange = (e) => setActivityName(e.target.value);

  const handleDateChange = (e, index) => {
    const newDates = [...dates];
    newDates[index] = e.target.value;
    setDates(newDates);
  };

  const handleHourChange = (e) => setHour(e.target.value);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!activityName || !hour || dates.some(date => !date)) {
      setError("Por favor, complete todos los campos.");
      return;
    }

    const fechasActividad = dates.map(fecha => ({ fecha, usuarios: [] }));

    try {
      await addDoc(collection(db, "actividades"), {
        nombre: activityName,
        isSingleClass,
        fechas: fechasActividad,
        hora: hour
      });
      //alert('Actividad agregada con éxito');
      Swal.fire({
        title: "Actividad agregada con éxito",
        icon: "success"
      });
    } catch (e) {
      console.error("Error adding document: ", e);
      setError("Hubo un error al agregar la actividad.");
    }
  };

  return (
    <Container>
      <h1 className={`mt-4 ${style.title}`}>Agregar actividad</h1>
      <Card className="mt-4 p-4">
        <Form onSubmit={handleSubmit}>
          <Form.Group as={Row} controlId="activityName">
            <Form.Label column sm={2}>Nombre de la actividad:</Form.Label>
            <Col sm={10}>
              <Form.Control
                type="text"
                value={activityName}
                onChange={handleNameChange}
                required
              />
            </Col>
          </Form.Group>

          <Form.Group as={Row} controlId="hour">
            <Form.Label column sm={2}>Hora de la actividad:</Form.Label>
            <Col sm={10}>
              <Form.Control
                type="time"
                value={hour}
                onChange={handleHourChange}
                required
              />
            </Col>
          </Form.Group>

          <Form.Group as={Row} controlId="isSingleClass">
            <Form.Label column sm={2}>¿Es una clase única?</Form.Label>
            <Col sm={10}>
              <Form.Check
                type="checkbox"
                checked={isSingleClass}
                onChange={handleCheckboxChange}
              />
            </Col>
          </Form.Group>

          <Form.Group as={Row} controlId="dates">
            <Form.Label column sm={2}>Fechas:</Form.Label>
            <Col sm={10}>
              {dates.map((date, index) => (
                <Row key={index} className="mb-2">
                  <Col sm={10}>
                    <Form.Control
                      type="date"
                      value={date}
                      onChange={(e) => handleDateChange(e, index)}
                      required
                    />
                  </Col>
                  <Col sm={2}>
                    {index > 0 && (
                      <Button
                        variant="danger"
                        type="button"
                        onClick={() => setDates(dates.filter((_, i) => i !== index))}
                      >
                        Eliminar
                      </Button>
                    )}
                  </Col>
                </Row>
              ))}
              {!isSingleClass && (
                <Button
                  variant="dark"
                  type="button"
                  onClick={() => setDates([...dates, ''])}
                >
                  Agregar fecha
                </Button>
              )}
            </Col>
          </Form.Group>

          {error && <Alert variant="danger">{error}</Alert>}

          <Button variant="dark" type="submit" className={`mt-4 ${style.actividadBtn}`}>
            Agregar actividad
          </Button>
        </Form>
      </Card>
    </Container>
  );
};

export default AgregarActividad;
